<template>
    <router-link :to="{ name: item.route }">
        <v-list-item
            @click="navigate(item)"
        >
            <v-list-item-action>
                <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-title>
                {{ item.text }}
            </v-list-item-title>
        </v-list-item>
    </router-link>
</template>

<script>
export default {
    components: {
        
    },
    props: [
        // This has been disabled in the initial lint setup - if you are working on this page please determine the correct type for these properties
        //eslint-disable-next-line
        "item"
    ],
    data() {
        return {
            
        };
    },
    computed: {
        
    },
    methods: {
        navigate(item) {
            this.$router.push({ name: item.route });

            this.$store.commit("generalStore/hideNavDrawer");
        }
    }
};
</script>

<style>

</style>
